module.exports = __webpack_public_path__ + "static/media/intro-photowall-14.785585c2.jpg";